module.exports = __webpack_public_path__ + "img/Logo-TOCC.9e010528.jpg";